import { FormComponent, UiComponent } from 'components';
import { usePageOption } from 'hooks';
import useModal from 'hooks/useModal';
import { EnrollQuery } from 'queries';
import React, { useState } from 'react';
import { IEnrollUserCandidate } from 'types';
import VolunteerAddFormModal from './VolunteerAddFormModal';
import { Link, useParams } from 'react-router-dom';
import { useAppSelector } from 'stores';
import { USER_MENU_URL } from 'data/menu';

function VolunteerAddModal() {
  const { id } = useParams<{ id: string }>();
  const { handleModal } = useModal();
  const canViewUser = useAppSelector(
    (s) => s.auth.user?.permissions.includes('user:detail') ?? false,
  );

  const pageState = usePageOption(10);
  const [name, setName] = useState<string>();
  const { data } = EnrollQuery.useGetUserCandidates({
    eventId: Number(id),
    page: pageState.pageOption.page,
    size: pageState.pageOption.size,
    name,
  });

  const handleSearch = (form: { name?: string }) => {
    setName(form.name || undefined);
    pageState.handlePage({ ...pageState.pageOption, page: 1 });
  };

  return (
    <div>
      <FormComponent.Form submit={handleSearch}>
        <FormComponent.SearchInput
          name="name"
          placeholder="이름으로 검색해주세요"
          css={{ width: '100%' }}
        />
      </FormComponent.Form>
      <ul>
        {data?.data.map((user: IEnrollUserCandidate) => (
          <li
            key={user.id}
            css={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: '4px',
              justifyContent: 'space-between',
              borderBottom: '1px solid #ddd',
              marginTop: '4px',
              padding: '4px 0',
            }}
          >
            {canViewUser ? (
              <Link
                to={`${USER_MENU_URL.회원목록}/${user.id}`}
                target="_blank"
                css={(theme) => ({
                  textDecoration: 'underline',
                  color: theme.color.primary,
                })}
              >
                {user.name} ({user.phone})
              </Link>
            ) : (
              <p>
                {user.name} ({user.phone})
              </p>
            )}
            <UiComponent.Button
              variant="contained"
              color="primary"
              onClick={() =>
                handleModal(
                  '참석자 추가',
                  <VolunteerAddFormModal user={user} />,
                  <></>,
                )
              }
            >
              추가
            </UiComponent.Button>
          </li>
        ))}
      </ul>
      <UiComponent.Pagination {...pageState} totalPage={data?.totalPages} />
    </div>
  );
}

export default VolunteerAddModal;
